/**
 * Countries where Ride has car supply.
 *
 * Ride is US-only today — ride-frontend pins `country=US` in its own search and
 * eligibility paths. Outdoorsy ships nine country editions, so a Ride link shown
 * anywhere else is a guaranteed zero-result search on a second brand.
 *
 * Add a country here when Ride's supply actually lands there.
 */
export const RIDE_SUPPLY_COUNTRIES = ['US'];

/**
 * `country` is an ISO-3166 alpha-2 code, matching the convention used by
 * `usCountryCode` in useDamageProtectionService and by `useLocaleSettings().country`.
 *
 * An absent or unrecognized country returns false — we don't send a Guest to a
 * cross-brand search we can't place on the map.
 */
export const hasRideSupply = (country?: string | null): boolean =>
  !!country && RIDE_SUPPLY_COUNTRIES.includes(country);
